import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { twMerge } from 'tailwind-merge';
import { TagType } from '../../constants';

type TimeTagProps = {
  type: TagType;
  onClick: (type: TagType, value?: number) => void;
  value?: number;
  selected?: boolean;
};

export const TimeTag = ({ type, value, onClick, selected }: TimeTagProps) => {
  const { t } = useTranslation();

  const handleClick = useCallback(() => {
    onClick(type, value);
  }, [onClick, type, value]);

  return (
    <button
      type="button"
      onClick={handleClick}
      className={twMerge(
        'text-primary-300 max-w-1/2 h-fit basis-1/2 rounded-md border border-gray-200 bg-gray-100 p-[5px] text-sm font-bold text-gray',
        selected && 'border-blue-500 bg-blue-500 text-white',
      )}
    >
      {t(type, { value })}
    </button>
  );
};
